import { type LinkColor, type LinkSize } from "ui/link/link.types";

/**
 * Figma's `MUI/link/labelSmall` and `labelMedium` (14/20 and 16/24, bold) are not theme variants: they
 * are exactly `h6` and `h5`'s metrics, so the link takes those steps.
 */
export const LINK_TYPE_VARIANT = {
  small: "h6",
  medium: "h5",
} as const satisfies Record<LinkSize, "h5" | "h6">;

/**
 * Figma's `inherit` link is a fixed grey — `text.secondary`, stepping to `text.primary` on hover — rather
 * than MUI's "take the parent's colour". A design decision (2026-10-16), so it maps onto MUI's own
 * `textSecondary` instead of `inherit`.
 */
export const LINK_MUI_COLOR = {
  primary: "primary",
  inherit: "textSecondary",
  error: "error",
} as const satisfies Record<LinkColor, string>;

/** `link/{size}/radius`: the corner of the focus ring. */
export const LINK_FOCUS_RADIUS = {
  small: "small",
  medium: "medium",
} as const satisfies Record<LinkSize, "small" | "medium">;

/**
 * Figma draws the underline on the line box's last pixel row: 5px under the baseline at `small`, 6px at
 * `medium`. Measured against the render, as the font's own position is 2px under it at both sizes.
 */
export const LINK_UNDERLINE_OFFSET = {
  small: 4,
  medium: 5,
} as const satisfies Record<LinkSize, number>;
